export default "__VITE_ASSET__kPSVAHpZ__"